<!--login-column  -->
<div class="login-column" style="padding-top: 10px;">
    <div class="login-column_header">
        <a (click)="onClickNavigation('')"><img src="../../../../assets/images/bim-logo.png" alt="Business in Maharashtra"></a>
        <div class="clearfix"></div>
        <h4>Login To Explore </h4>
    </div>
    <div class="main-register-holder tabs-act">
        <div class="main-register fl-wrap">
            <ul class="tabs-menu fl-wrap no-list-style">
                <li class="current"><a title="Login"><i class="fal fa-sign-in-alt"></i> Login</a></li>
                <li><a (click)="onClickNavigation('register')" title="Register"><i class="fal fa-user-plus"></i> Register</a>
                </li>
            </ul>
            <!--tabs -->
            <div class="tabs-container">
                <div class="tab">
                    <!--tab -->
                    <div id="tab-1" class="tab-content first-tab ">
                        <div *ngIf="alert" class="mt-4" [ngClass]="alert.cssClass">
                            {{alert.message}}
                        </div>
                        <div class="custom-form">
                            <form [formGroup]="loginForm" (ngSubmit)="loginUser()">
                                <div class="field">
                                    <label for="email">Username or Email Address <span>*</span> </label>
                                    <input type="text" id="email" formControlName="email" class="w-full" name="email"
                                        placeholder="Enter your email" />
                                    <small *ngIf="email.invalid && (email.dirty || email.touched)"
                                        class="form-text text-danger text-start">
                                        <div *ngIf="email.errors?.['required']">Email is required.</div>
                                        <div *ngIf="email.errors?.['email']">Email should be valid</div>
                                    </small>
                                </div>
                                <div class="field">
                                    <label for="password">Password <span>*</span> </label>
                                    <div class="input-group mb-3">
                                        <input id="password" [type]="fieldTextType ? 'text' : 'password'" formControlName="password" class="form-control w-75" name="password"
                                        placeholder="Enter your password" />
                                        <button class="btn btn-secondary password-view" type="button" id="password" (click)="toggleFieldTextType()">
                                            <i class="fal fa-eye-slash" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
                                        </button>
                                    </div>
                                    <small *ngIf="password.invalid && (password.dirty || password.touched)"
                                        class="block form-text text-danger text-start">
                                        <div *ngIf="password.errors?.['required']">Password is required.</div>
                                    </small>
                                </div>
                                <button type="submit" class="btn btn-primary w-100 mt-2" title="Log In"> Log In <i
                                        class="fas fa-caret-right"></i> </button>
                                <div class="clearfix"></div>
                                <div class="filter-tags">
                                    <input id="check-a3" type="checkbox" name="check">
                                    <label for="check-a3">Remember me</label>
                                </div>
                            </form>
                            <div class="lost_password">
                                <a href="javascript:void(0);" (click)="clickEvent()" title="Forgot Password?">Forgot
                                    Password?</a>
                                <div class="lost-password-tootip" [ngClass]="addRemoveClass ? 'lpt_vis' : ''">
                                    <p>Enter your email and we will send you a password</p>
                                    <form [formGroup]="forgotForm" (ngSubmit)="forgotPassword()">
                                        <input name="fEmail" type="text" value="" formControlName="fEmail">
                                        <small *ngIf="fEmail.invalid && (fEmail.dirty || fEmail.touched)"
                                            class="block p-error red-bg_color" style="text-align: left;">
                                            <div *ngIf="fEmail.errors?.['required']">Email is required.</div>
                                            <div *ngIf="fEmail.errors?.['email']">Email should be valid</div>
                                        </small>
                                        <div *ngIf="alert" class="mt-4 text-success">
                                            {{alert.message}}
                                        </div>
                                        <button type="submit" class="btn btn-primary mt-2"> Send <i
                                                class="fas fa-caret-right"></i></button>
                                    </form>
                                    <div class="close-lpt" (click)="clickEvent()"
                                        [ngClass]="addRemoveClass ? 'lpt_vis' : ''"><i class="far fa-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="log-separator fl-wrap"><span>or</span></div>
                        <div class="fl-wrap">
                            <a class="btn btn-link mt-3" (click)="onClickNavigation('')" title="Back to Home"> Back to Home </a>
                        </div>
                    </div>
                    <!--tab -->
                </div>
                <!--tabs end -->
            </div>
        </div>
    </div>
</div>
<!--login-column end-->
<!--login-column-bg  -->
<div class="login-column-bg gradient-bg">
    <!--ms-container-->
    <div class="slideshow-container" data-scrollax="properties: { translateY: '300px' }">
        <div class="swiper-container">
            <div class="mySwiper_photo">
                <div class="swiper-wrapper">
                    <!--ms_item-->
                    <div class="swiper-slide">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../assets/images/bg/2.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                    <!--ms_item-->
                    <div class="swiper-slide ">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../../assets/images/bg/3.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                    <!--ms_item-->
                    <div class="swiper-slide">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../../assets/images/bg/4.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                </div>
            </div>
        </div>
    </div>
    <!--ms-container end-->
    <div class="login-promo-container">
        <div class="container">
            <div class="video_section-title fl-wrap">
                <h2>Get ready to start your exciting journey. <br> Our agency will lead you through the amazing digital
                    world</h2>
            </div>
        </div>
    </div>
</div>
<!--login-column-bg end-->